import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { FACTORY_ADDRESS } from "utils/Constants"
import { formatAddress, getSymbol } from "utils/Functions"
import { querySmartContract } from "utils/RpcHelper"

export function PairListPage() {
    const [pairs, setPairs] = useState<string[]>([])

    const loadTokenDetails = async () => {
        const { pairs } = await querySmartContract(FACTORY_ADDRESS, { registered_pair: {} })
        setPairs(pairs)
    }

    useEffect(() => {
        loadTokenDetails()
    }, [])

    return <div className="w-100 p-2 px-4">
        <h4>Available pair to swap</h4>
        <div className="preview-list">
            {
                pairs.map(e => <PairDetailItem pair={e} />)
            }
        </div>
    </div>
}


export function PairDetailItem(prop: { pair: string }) {
    const navigate = useNavigate()
    const [firstAssetSymbol, setFirstAssetSymbol] = useState("")
    const [secondAssetSymbol, setSecondAssetSymbol] = useState("")

    const loadPairInfo = async () => {
        try {
            const { asset_infos } = await querySmartContract(prop.pair, { pair: {} })
            if (asset_infos) {
                setFirstAssetSymbol(await getSymbol(asset_infos[0]))
                setSecondAssetSymbol(await getSymbol(asset_infos[1]))
            }
        } catch {
            alert("Cannot load pair info")
        }
    }

    useEffect(() => {
        loadPairInfo()
    }, [])

    return <div className="preview-item border-bottom">
        <div className="preview-thumbnail">
            <div className="preview-icon bg-success">
                <i className="mdi mdi-swap-horizontal"></i>
            </div>
        </div>
        <div className="preview-item-content d-flex flex-grow">
            <div className="flex-grow">
                <h6 className="preview-subject">{firstAssetSymbol}/{secondAssetSymbol}</h6>
                <p className="text-muted mb-0">{formatAddress(prop.pair)}</p>
            </div>
            <button onClick={() => navigate("/swap/" + prop.pair)} type="button" className="btn btn-primary">Swap</button>
        </div>
    </div>
}